import { render, staticRenderFns } from "./company-create-tenant-association-info.vue?vue&type=template&id=06ab83ce&"
import script from "./company-create-tenant-association-info.vue?vue&type=script&lang=js&"
export * from "./company-create-tenant-association-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports